var _defs, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 187.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0058a0;}.cls-2{fill:#fff;}.cls-3{fill:#c2202a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "popup_phone-back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.48,364.62l-220-15V227.31a6.36,6.36,0,0,1,6.36-6.36H350.12a6.36,6.36,0,0,1,6.36,6.36Z",
    transform: "translate(-136.48 -220.95)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 110,
    cy: 135.37,
    r: 51.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 110,
    cy: 135.37,
    r: 47.41
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 110,
    cy: 135.37,
    r: 42.99
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.16,379.43a22.06,22.06,0,0,1-4.68-1.81,57.9,57.9,0,0,1-18.24-13.39,55.06,55.06,0,0,1-10.68-17.52,7.78,7.78,0,0,1,.45-6.87,9,9,0,0,1,4.7-3.82,4.78,4.78,0,0,1,3.59-.27,4.61,4.61,0,0,1,1.45.86,28.19,28.19,0,0,1,6.46,8.76,3.89,3.89,0,0,1-1.35,5.05c-.28.22-.59.42-.87.64a3,3,0,0,0-1.12,3.8,16.39,16.39,0,0,0,2.1,3.87,19.86,19.86,0,0,0,8.07,6.47,2.69,2.69,0,0,0,2.55.21,4.36,4.36,0,0,0,1.18-1.12,7.54,7.54,0,0,1,2-1.94,4.35,4.35,0,0,1,4.4-.13,31.08,31.08,0,0,1,3.69,2.31c1.34.94,2.64,1.94,3.91,3,2,1.66,2.47,3.5,1.32,5.84a10.82,10.82,0,0,1-7.22,5.92l-.61.15Z",
    transform: "translate(-136.48 -220.95)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269,353.62a12.35,12.35,0,0,1,0,1.53,1.65,1.65,0,0,1-1.73,1.51,1.7,1.7,0,0,1-1.85-1.54c-.15-1.05-.2-2.12-.37-3.17a19.26,19.26,0,0,0-3.45-8.74,14.31,14.31,0,0,0-6-4.51,27.24,27.24,0,0,0-7.54-1.87c-1.12-.13-1.68-.74-1.64-1.71a1.81,1.81,0,0,1,1.87-1.89,19,19,0,0,1,11,3.1,21.23,21.23,0,0,1,8.5,10.39A17.85,17.85,0,0,1,269,353.62Z",
    transform: "translate(-136.48 -220.95)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.94,352.87c0,.19,0,.54,0,.88a1.67,1.67,0,0,1-1.68,1.75,1.69,1.69,0,0,1-1.93-1.58c-.26-1.46-.48-2.93-.88-4.35a8.05,8.05,0,0,0-5.65-5.7c-1.29-.42-2.64-.68-4-1a1.89,1.89,0,1,1,.38-3.76c5.86.53,10.24,3.27,12.75,8.71A11.43,11.43,0,0,1,262.94,352.87Z",
    transform: "translate(-136.48 -220.95)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.25,345.13a7.87,7.87,0,0,1,6.9,7.51,2,2,0,0,1-1.18,2,1.85,1.85,0,0,1-2.5-1.6,9.9,9.9,0,0,0-.52-2,3.62,3.62,0,0,0-2.76-2.08c-.38-.09-.76-.16-1.14-.27a1.56,1.56,0,0,1-1.24-1.44,1.91,1.91,0,0,1,1.06-1.84A9.08,9.08,0,0,1,250.25,345.13Z",
    transform: "translate(-136.48 -220.95)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopup);
export default __webpack_public_path__ + "static/media/popup.5a0fd712558dda0aa265a678ee79b204.svg";
export { ForwardRef as ReactComponent };